import React from 'react';

export default () => {
  return (
      
       <div>ERROR PAGE NOT FOUND!</div>
  )
}


